import AdvisorError from './AdvisorError';
class ObtainAdvisorError extends AdvisorError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ObtainAdvisorError', ...args);
    }
}
export default ObtainAdvisorError;
